import React, { useEffect, useState } from 'react';






function Orderbumpelement({ orderbump, index, productId, currency, selectedOrderbumps, toggleOrderbumpSelection, handleCheckboxChange}) {


  const roundToTwoDecimalPlaces = (number) => {
    return +(Math.round(Number.parseFloat(number) + "e+2")  + "e-2");
  }
  

//console.log("Aktuelle Orderbumpquantity: ",orderbump[0]['ips-mb-ordebumps-offer-quantity']);



  return (
   <>
    
    <div className="row p-3" key={index}>
      {orderbump[0] && (
        <div className="col-12 ips-orderbump">
         <label htmlFor={`ipsorderbumpCheckbox-${index}`} className="d-flex flex-row custom-checkbox ips-orderbump-header">
            <div className="d-flex justify-content align-items-center col-2 mt-1 mb-1 my-auto ips_orderimgmobile">

  <input
    type="checkbox"
    id={`ipsorderbumpCheckbox-${index}`}
    checked={selectedOrderbumps.includes(index)}
    onChange={() => {
      toggleOrderbumpSelection(index); // Hier die Funktion aufrufen
      handleCheckboxChange(
        index,
        productId,
        orderbump[0]['ips-mb-ordebumps-offer-quantity'],
        orderbump[0]['ips-mb-ordebumps-offer-product-type'],
        orderbump
      );
    }}
  />
  <span className="checkmark"></span>

             
              
            </div>
            {/* <div className="col-10 mt-1 px-1 ps-2 ips-orderbump-offertext"><span>{orderbump[0]['ips-mb-ordebumps-offer-offertext']}</span></div> */}
            <div className="col-10 mt-1 px-1 ps-2 ips-orderbump-offertext">
            <span dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-offertext'] }}></span>
          </div>
            </label>
          
  {/* -------------------------------------------------------------------------------------------------------------------------------------------------------------------- */}
          <div className="d-flex flex-row ips-orderbump-body">
            

          <div className="d-flex justify-content-center align-items-center col-2 mt-1 mb-1 my-auto ips_orderimgmobile ips-orderbumpitem-image">
              <a href={orderbump[0]['ips-mb-ordebumps-offer-product-productlink']}>
                <div dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-product-image'] }}></div>
              </a>
            </div>




           
            <div className="col-10 mt-1 px-1 ps-2 ips-orderbump-showprice">
            {/*  <div className="d-flex flex-row">{orderbump[0]['ips-mb-ordebumps-offer-product-name']}</div>  */}
              <div className="d-flex flex-row" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-product-name'] }}></div>
              {orderbump[0]['ips-mb-ordebumps-offer-product-type'] === 'variable' ? (
              <div className="d-flex flex-row ips-orderbump-total" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-pricerange'] }}></div>
            ) : (
              
              parseFloat(orderbump[0]['ips-mb-ordebumps-offer-calcdiscount']) > 0 ? (
                <>
               
                
                  <del aria-hidden="true" className="ips-orderbump-delamount" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-product-price'] }}></del>
                  
                  <ins className="ips-ins-element"><span className="ips-content-priceelement woocommerce-Price-amount amount"><bdi>{roundToTwoDecimalPlaces(parseFloat(orderbump[0]['ips-mb-ordebumps-offer-calcdiscount']))}
                  <span className="woocommerce-Price-currencySymbol">{currency}</span></bdi></span></ins>
                  
                
           
               
              </>
              ) : (
                <div className="d-flex flex-row ips-orderbump-total" dangerouslySetInnerHTML={{ __html: orderbump[0]['ips-mb-ordebumps-offer-product-price'] }}></div>
              )
            )}
            </div>
          </div>
        </div>
      )}
    </div>
    </>

  );
}





  


export default Orderbumpelement;